import React from "react"

import InvestorsComponent from "./Investors"
import investorFactory from "./investors.factory"

export const Investors = props => {
  const { data, theme } = props
  const componentProps = {
    theme,
    ...investorFactory.transform(data)
  }
  return <InvestorsComponent {...componentProps} />
}

export default Investors
